import Form from 'components/organisms/Form';
import { useContext, useState } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import RelatedDocumentsModal from 'components/molecules/RelatedDocumentsModal';
import ClassificationModal from 'components/molecules/ClassificationModal';
import { useParams } from 'react-router';
import tipoDocEnum from 'pools/tipoDocEnum';
import getKeyByValue from 'components/helpers/getKeyByValue';
import './styles.scss';

const SavePage = () => {
  const { tipoDoc } = useParams();
  const tipoDocId = getKeyByValue(tipoDocEnum, tipoDoc);
  const { relatedDocumentsModal, classificationModal } = useContext(GlobalContext);
  const [selectedLinks, setSelectedLinks] = useState([]);
  const title = `Cadastrar ${tipoDocId === 1 ? 'Nova Norma Técnica' : 'Novo Desenho Padrão'}`;
  const [relatedData, setRelatedData] = useState({ links: [], documents: [], files: [] });

  return (
    <>
      <div className="savePage">
        <Form Title={title} tipoDoc={tipoDocId} relatedData={relatedData} />
      </div>
      {relatedDocumentsModal.isVisible && (
        <RelatedDocumentsModal
          setRelatedData={setRelatedData}
          relatedData={relatedData}
          setSelectedLinks={setSelectedLinks}
          selectedLinks={selectedLinks}
        />
      )}
      {classificationModal.isVisible && <ClassificationModal />}
    </>
  );
};

export default SavePage;
